/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {EntityTypeEnum} from './entity-type.enum';
import {BusinessSettingsDisplayDataModel} from './models/business-settings-display-data.model';
import {EntityTreeBranchModel} from '../../../../shared/entity-tree/models/entity-tree-branch.model';

/**
 * PNC branch select action
 */
const pncBranchSelectAction = (displayData: BusinessSettingsDisplayDataModel,
                               branch?: Map<EntityTypeEnum, EntityTreeBranchModel>,
                               recursiveUpdate?: (entity: EntityTreeBranchModel,
                                                  branch: Map<EntityTypeEnum, EntityTreeBranchModel>) => void): void => {
    displayData.entitiesData.set(EntityTypeEnum.SHIP_TO_PARTIES, {
        ...displayData.entitiesData.get(EntityTypeEnum.SHIP_TO_PARTIES),
        hasPath: true,
        representParent: false
    });
    displayData.entitiesOrder.commonBranch.set(EntityTypeEnum.SHIP_TO_PARTIES, 4);

    displayData.entitiesData.set(EntityTypeEnum.SUPPLYING_PACKING_PLANTS, {
        ...displayData.entitiesData.get(EntityTypeEnum.SUPPLYING_PACKING_PLANTS),
        hasPath: false,
        representParent: true
    });
    displayData.entitiesOrder.commonBranch.set(EntityTypeEnum.SUPPLYING_PACKING_PLANTS, 3);

    if (recursiveUpdate != null && branch != null) {
        recursiveUpdate(branch.get(EntityTypeEnum.SHIP_TO_PARTIES), branch);
        recursiveUpdate(branch.get(EntityTypeEnum.SUPPLYING_PACKING_PLANTS), branch);
    }
};

/**
 * Return to original position (Claim and SPO branches select action)
 */
const returnToOriginalOrderBranchSelectAction = (displayData: BusinessSettingsDisplayDataModel,
                                                 branch?: Map<EntityTypeEnum, EntityTreeBranchModel>,
                                                 recursiveUpdate?: (entity: EntityTreeBranchModel,
                                                                    branch: Map<EntityTypeEnum, EntityTreeBranchModel>)
                                                         => void): void => {
    if (displayData.entitiesOrder.commonBranch.get(EntityTypeEnum.SHIP_TO_PARTIES) !== 3
            && displayData.entitiesOrder.commonBranch.get(EntityTypeEnum.SUPPLYING_PACKING_PLANTS) !== 4) {
        displayData.entitiesData.set(EntityTypeEnum.SHIP_TO_PARTIES, {
            ...displayData.entitiesData.get(EntityTypeEnum.SHIP_TO_PARTIES),
            hasPath: false,
            representParent: true
        });
        displayData.entitiesOrder.commonBranch.set(EntityTypeEnum.SHIP_TO_PARTIES, 3);

        displayData.entitiesData.set(EntityTypeEnum.SUPPLYING_PACKING_PLANTS, {
            ...displayData.entitiesData.get(EntityTypeEnum.SUPPLYING_PACKING_PLANTS),
            hasPath: true,
            representParent: false
        });
        displayData.entitiesOrder.commonBranch.set(EntityTypeEnum.SUPPLYING_PACKING_PLANTS, 4);

        if (recursiveUpdate != null && branch != null) {
            recursiveUpdate(branch.get(EntityTypeEnum.SHIP_TO_PARTIES), branch);
            recursiveUpdate(branch.get(EntityTypeEnum.SUPPLYING_PACKING_PLANTS), branch);
        }
    }
};

/**
 * Varibale to export functions
 */
const displayDataFunctions = {
    pncBranchSelectAction,
    returnToOriginalOrderBranchSelectAction
};

export default displayDataFunctions;
